import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Banner from "./images/contact_us.jpg";
import { Footer } from "./components/Footer";
import { Helmet } from "react-helmet"; 

export const Mkenquiery = () => {
  const [grievanceform, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!grievanceform);
  };
  return (
    <>
      <Helmet>
        <title>Premier Energies | Offices Across India & North America</title>
        <meta
          name="description"
          content="Contact Premier Energies - Solar Cell & Solar Module Requirements - Call@ +91-9490167793 - Email # grievance@premierenergies.com"
        />
        <link rel="canonical" href="https://premierenergies.com/contact-us" />
        <meta
          property="og:url"
          content="https://premierenergies.com/contact-us"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Premier Energies | Offices Across India & North America"
        />
        <meta
          name="og:description"
          content="Contact Premier Energies - Solar Cell & Solar Module Requirements - Call@ +91-9490167793 - Email # grievance@premierenergies.com"
        ></meta>
         
      </Helmet>
      <Header />
      <section id="banner" className="p-0">
        <div className="banner">
          <img src={Banner} alt="img"/>
          <div className="container">
            <div className="homcolft position-absolute position-right left">
              <span className="colorborder">
                <em></em>
              </span>
              <h2
                data-aos="fade-down"
                data-aos-offset="100"
                data-aos-easing="ease-in-sine"
                data-aos-once="true"
                data-aos-duration="500"
              >
                Go Green, Save Green
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="contactus pb-0">
        <div className="container">
          <div className="row">
            <div className="web-container">
              <div className="title centerheading">
                <div className="centerit">
                  <span className="colorborder">
                    <em></em>
                  </span>
                  <h1
                    data-aos="fade-down"
                    data-aos-offset="100"
                    data-aos-easing="ease-in-sine"
                    data-aos-once="true"
                    data-aos-duration="500"
                  >
                  ENQUIRE NOW

                  </h1>
                </div>
              </div>
            <iframe
                  src="https://page-velocity-4445.my.salesforce-sites.com/PremierEnergiesLeadForm"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Enquiry Form"  className="custom-iframe"
                ></iframe>
            
            </div>
          </div>
        </div>
      </section> 
      <Footer />
    </>
  );
};